import React from "react";

const Select = ({
  data,
  options_mapping,
  label,
  name,
  handleInputChange,
  width,
  multiple = false,
  is_invalid,
}) => {
  return (
    <div className="form-group">
      <label style={{ fontSize: "15px" }} htmlFor={name}>
        {label}
      </label>
      <select
        name={name}
        value={data ? data : multiple ? [] : ""}
        onChange={(e) => {
          handleInputChange(e);
        }}
        className={`form-control ${is_invalid && "is-invalid"}`}
        id={name}
        style={{ width: `${width}%` }}
        multiple={multiple}
      >
        {!multiple && <option value="">Select an option</option>}

        {options_mapping.map((value, index) => (
          <option value={value.id} key={index}>
            {value.value}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Select;
